import { Skeleton } from '@/components/ui/skeleton';
import { PageHeaderSkeleton } from './PageHeaderSkeleton';
import { PageWrapper } from '@/components/layout';

/**
 * Skeleton for content pages (Terms, Privacy, About, Mission).
 * Reserves ~520px for header + text content sections.
 */
export function ContentPageSkeleton() {
  return (
    <PageWrapper>
      <PageHeaderSkeleton showDescription={true} />

      <div className="py-8 space-y-8 max-w-3xl">
        {/* Date line */}
        <Skeleton className="h-4 w-40" />

        {/* Content sections */}
        {Array.from({ length: 5 }).map((_, sectionIndex) => (
          <section key={sectionIndex} className="space-y-3">
            {/* Section heading */}
            <Skeleton className="h-6 w-1/3" />

            {/* Paragraph lines */}
            <div className="space-y-2">
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-5/6" />
              {sectionIndex % 2 === 0 && <Skeleton className="h-4 w-3/4" />}
            </div>
          </section>
        ))}
      </div>
    </PageWrapper>
  );
}
